export function createCountsFromEquipment(equipment) {
    let counts = []

    equipment.forEach(item => {
        let count = {
            equipment: parseInt(item.id, 10),
            expectedQuantity: parseInt(item.quantity, 10),
            countedQuantity: '',
            name: item.name,
            category: item.category
        }

        counts.push(count)
    })

    return counts
}

export function createSubmitData(formData) {

    let submitData = {
        dateCounted: formData.dateCounted.format("YYYY-MM-DD"),
    }

    let logs = []

    formData.equipment.forEach(item => {
        let count = {
            expectedQuantity: parseInt(item.expectedQuantity, 10),
            countedQuantity: item.countedQuantity !== '' ? parseInt(item.countedQuantity, 10) : null,
            equipment: parseInt(item.equipment, 10)
        }

        logs.push(count)
    })

    submitData['logs'] = [...logs]

    return submitData
}
